import { inject, Injectable } from '@angular/core';
import { PropertyType } from '@rma/generic/domain/types';
import { FeatureFlags, FeatureFlagService } from '@rma/generic/util/feature-flags';

@Injectable({
  providedIn: 'root',
})
export class PropertyTypeGroupingService {
  private readonly featureService = inject(FeatureFlagService);

  public readonly propertyTypeGrouping: Record<PropertyType, string>;

  constructor() {
    this.propertyTypeGrouping = this.featureService.getFeature<Record<PropertyType, string>>(
      FeatureFlags.PropertyTypeGrouping,
      {} as Record<PropertyType, string>,
    );
  }

  public getPropertyTypesFromGroup(propertyTypes: PropertyType[]): PropertyType[] {
    return propertyTypes ? propertyTypes.reduce((acc, curr) => acc.concat(this.getPropertyTypeGrouping(curr)), [] as PropertyType[]) : [];
  }

  public getPropertyTypeGroup(propertyType: PropertyType): string {
    return this.propertyTypeGrouping[propertyType];
  }

  private getPropertyTypeGrouping(propertyType: PropertyType): PropertyType[] {
    return (Object.keys(this.propertyTypeGrouping) as PropertyType[]).filter((key) => this.propertyTypeGrouping[key] === propertyType);
  }
}
